module.exports = __webpack_public_path__ + "img/open-in-new-white.d1728a55.svg";